export default __webpack_public_path__ + "static/media/MoreMobileActive.2edbb214.svg";